import { createContext, useContext } from "react";

export interface GroupHighlightContextValue {
  groupId: string;
  /** When true, descendant settings use the compact (tight) highlight style. */
  compact: boolean;
}

/**
 * Published by `<GroupHighlight>` so a descendant `<SettingHighlight>` knows
 * which group it belongs to. `undefined` means the setting is standalone (not
 * rendered inside any group).
 */
export const GroupHighlightContext = createContext<
  GroupHighlightContextValue | undefined
>(undefined);

export function useGroupHighlightContext():
  | GroupHighlightContextValue
  | undefined {
  return useContext(GroupHighlightContext);
}
